import { useState } from "react"
import { Button, Grid, IconButton, MenuItem, Select, Box } from '@mui/material'
import TuneIcon from '@mui/icons-material/Tune';
import { DrawerShoppingCart } from "./components/DrawerShoppingCart";
import { CarrucelcategoriesKFC } from "./CarrucelcategoriesKFC";
import { ProductsKFC } from "./ProductsKFC";
import { HeaderKFC } from "./HeaderKFC";
import { useSearcherStore } from "../../hooks/useSearcherStore";
import { DrawerSelectCustomer } from "./components/DrawerSelectCustomer";
import { DrawerSelectSalesman } from "./components/DrawerSelectSalesman";
import SearcherKFCFilterModal from "./components/SearcherKFCFilterModal";
import { ProductsTableKFC } from "./ProductsTableKFC";

const relevances = [
    { id: 1, name: 'Relevancia' },
    { id: 2, name: 'Mejor descuento' },
    { id: 3, name: 'Mayor precio' },
    { id: 4, name: 'Menor precio' }
]

export const SearcherKFC: React.FC<any> = (props): JSX.Element | any => {

    const { getSearchProducts, getFilterProducts } = useSearcherStore();
    const { selectedCategory, setSelectedCategorySearcher, selectedPriceList, setPricelistName, filterProducts, setFilterProducts } = useSearcherStore();

    const [loadingproducts, setLoadingproducts] = useState<boolean>(false);
    const [loadingsearch, setLoadingsearch] = useState<boolean>(false);
    const [showModalFilter, setShowModalFilter] = useState<boolean>(false);
    const [products, setProducts] = useState<any>([]);
    const [datasearch, setdatasearch] = useState<any>([]);
    const [typeList, setTypeList] = useState<any>('');

    const [page, setPage] = useState<number>(1);
    const [perPage, setPerpage] = useState<number>(10);
    const [totalRecords, setTotalRecords] = useState<number>(0);

    const [viewType, setViewType] = useState<'cards' | 'table'>('cards');  // Estado para cambiar la vista

    const getSearchProductsApi = async(data:any) => {
        try {
            setLoadingsearch(true);
            const response = await getSearchProducts({...data, page: page, perPage: perPage});
            if(!response){
                setdatasearch([]);
                setProducts([]);
                setTotalRecords(0);
                setLoadingsearch(false);
                return false;
            }
            const { detail, total } = response as { detail?: any[]; total?: number };
            const rows = Array.isArray(detail) ? detail : [];
            setdatasearch(rows);
            setProducts(rows);
            setTotalRecords(typeof total === 'number' ? total : rows.length);
            setLoadingsearch(false);
        } catch (error) {
            setLoadingsearch(false);
        }
    }

    const getFilterProductsApi = async() => {
        try {
            setLoadingproducts(true);
            const response = await getSearchProducts({ ...filterProducts, page: page, perPage: perPage});
            if(!response){
                setProducts([]);
                setTotalRecords(0);
                setLoadingproducts(false);
                return false;
            }
            const { detail, total } = response as { detail?: any[]; total?: number };
            const rows = Array.isArray(detail) ? detail : [];
            const name_pricelist = rows[0]?.name_pricelist ?? null;
            setPricelistName(name_pricelist || null);
            setProducts(rows);
            setTotalRecords(typeof total === 'number' ? total : rows.length);
            setLoadingproducts(false);
        } catch (error) {
            setLoadingproducts(false);
        }
    }

    return (<>

        <HeaderKFC
            getFilterProducts={getFilterProductsApi} 
            setdatasearch={setdatasearch} 
            datasearch={datasearch}
            setProducts={setProducts}
            setTypeList={setTypeList}
        />

        <Grid container spacing={2}>

            {
                selectedCategory == null
                ?
                    // <CarrucelcategoriesKFC 
                    //     getFilterProducts={getFilterProductsApi} 
                    //     setProducts={setProducts}
                    //     setTypeList={setTypeList}
                    // />
                    <></>
                :
                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        {/* <Button
                            onClick={() => setSelectedCategorySearcher(null)}
                            sx={{ 
                                backgroundColor: '#ffffff',
                                border: '1px solid #69ABC3',
                                borderRadius: '10px',
                                color: '#69ABC3',
                                height: '25px',
                                padding: '6px 16px',
                                textTransform: 'none',
                                width: 160,
                                "&:hover": { backgroundColor: "#ffffff" }
                            }}
                        >
                            Ver más categorías
                        </Button> */}
                    </Grid>
            }

            <Grid item container xs={12} spacing={2}>
                {/* <Grid item xs={12} md={1} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <IconButton onClick={() => setShowModalFilter(!showModalFilter)}>
                        <TuneIcon fontSize="large" />
                    </IconButton>
                </Grid> */}
                {/* <Grid item xs={12} md={2} >
                    <Button sx={{ width: '150px', color: '#000000', fontSize: '12px', fontWeight: 'bolder', border: '2px solid #D0D0D0', borderRadius: '15px', margin: '10px' }}>
                        Lo más buscado
                    </Button>
                </Grid>
                <Grid item xs={12} md={2} >
                    <Button sx={{ width: '150px', color: '#000000', fontSize: '12px', fontWeight: 'bolder', border: '2px solid #D0D0D0', borderRadius: '15px', margin: '10px' }}>
                        Descuentos
                    </Button>
                </Grid>
                <Grid item xs={12} md={2} >
                    <Button sx={{ width: '150px', color: '#000000', fontSize: '12px', fontWeight: 'bolder', border: '2px solid #D0D0D0', borderRadius: '15px', margin: '10px' }}>
                        Nuevo
                    </Button>
                </Grid>
                <Grid item xs={12} md={2} >
                    <Button sx={{ width: '150px', color: '#000000', fontSize: '12px', fontWeight: 'bolder', border: '2px solid #D0D0D0', borderRadius: '15px', margin: '10px' }}>
                        Para ti
                    </Button>
                </Grid>
                <Grid item xs={12} md={3} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Select defaultValue={1} size="small" sx={{ borderRadius: '25px', width: '200px', height: '35px' }}>
                        {relevances?.map((option) => ((<MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>)))}
                    </Select>
                </Grid> */}
            </Grid>
            {/* {showModalFilter && ( */}
                <Grid item xs={12} md={12} sx={{ padding: '16px' }}>
                    <SearcherKFCFilterModal
                        setShowFilters={setShowModalFilter}
                        getFilterProducts={getFilterProductsApi}
                        setViewType={setViewType}
                        viewType={viewType}
                    />
                </Grid>
            {/* )} */}

            <Grid item xs={12} md={12} sx={{ padding: '16px' }}>
                {/* Mostrar Productos en Cards o en Tabla según la opción seleccionada */}
                {viewType === 'cards' ? (
                    <ProductsKFC 
                        setProducts={setProducts}
                        products={products || []} 
                        getFilterProducts={getFilterProductsApi}
                        loadingproducts={loadingproducts}
                        typeList={typeList} 
                        setTypeList={setTypeList}
                        page={page}
                        perPage={perPage}
                        setPage={setPage}
                        totalRecords={totalRecords}
                    />
                ) : (
                    <ProductsTableKFC
                        products={products || []} 
                    />
                )}
            </Grid>
        </Grid >

        <DrawerShoppingCart />
        <DrawerSelectCustomer getFilterProducts={getFilterProductsApi} setProducts={setProducts} setTypeList={setTypeList} />
        <DrawerSelectSalesman getFilterProducts={getFilterProductsApi} setProducts={setProducts} setTypeList={setTypeList} />
    </>)

}
